import axios from 'axios'
import router from '@/router'
import store from '@/store'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_apiBaseURL,
  timeout: 5 * 60 * 1000, // 5 minutes
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

// Error Codes - https://developer.mozilla.org/en-US/docs/Web/HTTP/Status

function catchErrors(error) {
  if (error.response?.status) {
    if (error.response.status >= 500) {
      store.commit('SET_NETWORK_ERROR', error)
      router.push({ name: 'network-issue' })
    } else if (error.response.status == 401) {
      store.commit('SET_NETWORK_ERROR', error)
      router.push({ name: 'network-issue' })
    } else if (error.response.status >= 400) {
      router.push({ name: '404' })
    } else {
      store.commit('SET_RESPONSE_TYPE', 'error')
      store.commit('SET_RESPONSE_MSG', error.response.statusText)
    }
  } else {
    store.commit('SET_NETWORK_ERROR', error)
    router.push({ name: 'network-issue' })
  }
  store.commit('SET_LOADING_APP', false)
}

// Axios - https://github.com/axios/axios#example
// HTTP request methods: https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods

apiClient.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    catchErrors(error)
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => {
    if (response.config.method == 'post') {
      if (response.status <= 100) {
        store.commit('SET_RESPONSE_TYPE', 'info')
      } else if (response.status <= 200) {
        store.commit('SET_RESPONSE_TYPE', 'success')
      } else {
        store.commit('SET_RESPONSE_TYPE', 'error')
      }
    }
    return response
  },
  (error) => {
    catchErrors(error)
    return Promise.reject(error)
  }
)

export { apiClient }
